module.exports = __webpack_public_path__ + "img/masterKongTitle.5d99e02b.png";